module.exports = __webpack_public_path__ + "assets/img/rule-after-back.36a75a55.png";